import { AppLink } from '@borg/types';

class SiteLinksRepository extends Repository<AppLink> {
  getMany() {
    return this._getMany({ url: '/apps/links', cache: 'always' });
  }
}

export const siteLinksRepository = new SiteLinksRepository();
